/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemsRefetchWrapper_portfolioNode$ref = any;
type Recommendations_trending$ref = any;
type RequestShippingQuoteModal_viewer$ref = any;
type Tiles_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ItemsContainer_viewer$ref: FragmentReference;
export type ItemsContainer_viewer = {|
  +id: string,
  +user?: ?{|
    +serviceId: ?string,
    +isVerifiedTrade: ?boolean,
    +profile: ?{|
      +currency: ?Currency,
      +email: ?string,
    |},
  |},
  +itemsPortfolios?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +isPublic: ?boolean,
        +serviceId: ?string,
        +totalPortfolioItems: ?{|
          +totalResults: ?number
        |},
        +$fragmentRefs: ItemsRefetchWrapper_portfolioNode$ref,
      |}
    |}>
  |},
  +$fragmentRefs: Recommendations_trending$ref & RequestShippingQuoteModal_viewer$ref & Tiles_viewer$ref,
  +$refType: ItemsContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 1,
  "type": "Int"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ItemsContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "portfolioTypes",
      "type": "[PortfolioTypes]"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "loadPortfolioData",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Recommendations_trending",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "RequestShippingQuoteModal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Tiles_viewer",
      "args": null
    },
    (v0/*: any*/),
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "loadPortfolioData",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "itemsPortfolios",
          "name": "portfolios",
          "storageKey": null,
          "args": [
            (v1/*: any*/),
            {
              "kind": "Variable",
              "name": "portfolioTypes",
              "variableName": "portfolioTypes",
              "type": "[PortfolioTypes]"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "isPublic",
                      "args": null,
                      "storageKey": null
                    },
                    (v2/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": "totalPortfolioItems",
                      "name": "items",
                      "storageKey": "items(first:1)",
                      "args": [
                        (v1/*: any*/)
                      ],
                      "concreteType": "PortfolioItemsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "totalResults",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "ItemsRefetchWrapper_portfolioNode",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isVerifiedTrade",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "profile",
              "storageKey": null,
              "args": null,
              "concreteType": "Profile",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '06a7a10242edaa40474f0cae5d16f274';
module.exports = node;
